// Deep clone for simulator snapshots (Simulator snapshotAtWave/resumeFrom).
//
// Keeps prototypes (entities are class instances), shared references and
// cycles; Map / Set / arrays / typed arrays are rebuilt. Functions are kept
// by reference — so a closure-backed object (the seeded rng) is shared
// between the original and the clone; the simulator restores its state
// explicitly via rng.setState() on resume.

export function deepClone(root) {
  const seen = new Map();
  const clone = v => {
    if (v === null || typeof v !== 'object') return v;
    if (seen.has(v)) return seen.get(v);
    if (Array.isArray(v)) {
      const out = new Array(v.length);
      seen.set(v, out);
      for (let i = 0; i < v.length; i++) out[i] = clone(v[i]);
      return out;
    }
    if (v instanceof Map) {
      const out = new Map();
      seen.set(v, out);
      for (const [k, x] of v) out.set(clone(k), clone(x));
      return out;
    }
    if (v instanceof Set) {
      const out = new Set();
      seen.set(v, out);
      for (const x of v) out.add(clone(x));
      return out;
    }
    if (ArrayBuffer.isView(v)) {
      const out = v.slice();
      seen.set(v, out);
      return out;
    }
    const out = Object.create(Object.getPrototypeOf(v));
    seen.set(v, out);
    for (const key of Reflect.ownKeys(v)) {
      const desc = Object.getOwnPropertyDescriptor(v, key);
      if ('value' in desc) desc.value = clone(desc.value);
      Object.defineProperty(out, key, desc);
    }
    return out;
  };
  return clone(root);
}
